import { forwardRef, createElement } from 'react';
import cn from 'classnames';

const Backdrop = /*#__PURE__*/forwardRef(function Backdrop(props, ref) {
  const className = cn('fixed inset-0 cursor-default overflow-y-auto bg-purple-darker/[0.3] aria-hidden:hidden z-[996]', props.className);
  return createElement("div", Object.assign({}, props, {
    className: className,
    ref: ref
  }));
});

export { Backdrop };
//# sourceMappingURL=Backdrop.js.map
